module.exports = __webpack_public_path__ + "img/badge-watchers.77d9ad70.png";